import { splitLinks } from '@/lib/links'

/**
 * User-written text with its web addresses made clickable. Links open in a new
 * tab and are marked as user content, so they pass no referrer or ranking.
 */
export function LinkedText({ text }: { text: string }) {
  // One block of its own: some containers (.content-row) are flex rows, which
  // laid each text run and link out as a separate column.
  return (
    <span className="linked-text">
      {splitLinks(text).map((part, index) =>
        part.href ? (
          <a
            key={index}
            className="linked-text-link"
            href={part.href}
            target="_blank"
            rel="noopener noreferrer nofollow ugc"
            onClick={(event) => event.stopPropagation()}
          >
            {part.text}
          </a>
        ) : (
          part.text
        ),
      )}
    </span>
  )
}
